module.exports = __webpack_public_path__ + "img/c01_buildingtechgreekfire_Normal_ua.947a498a.webp";